<mvms-tab-navigation [navLinks]="navLinks"></mvms-tab-navigation>
<div class="content">
  <router-outlet></router-outlet>
</div>
